module.exports = __webpack_public_path__ + "img/icons-fill-contractor-saphhire.2fed3cba.svg";